<h2>
    {{ group.text.fullLabel }}
    <app-tooltip data-html2canvas-ignore [text]="group.text.summary"></app-tooltip>
</h2>

<div class="container">
    <form #filterForm="ngForm" class="filter-form">
        <section class="complete-field">
            <label>{{'reports.sample.completeSelect.fullLabel' | translate}}</label>
            <mat-radio-group class="complete-options" [(ngModel)]="isComplete" name="{{group.code}}-filter">
                <div>
                    <mat-radio-button [value]="null"> {{'reports.sample.all.shortLabel' | translate}} </mat-radio-button>
                    <app-tooltip [text]="'reports.sample.all.summary' | translate"></app-tooltip>
                </div>
                <div>
                    <mat-radio-button [value]="true"> {{'reports.sample.complete.shortLabel' | translate}} </mat-radio-button>
                    <app-tooltip [text]="'reports.sample.complete.summary' | translate"></app-tooltip>
                </div>
                <div>
                    <mat-radio-button [value]="false"> {{'reports.sample.notComplete.shortLabel' | translate}} </mat-radio-button>
                    <app-tooltip [text]="'reports.sample.notComplete.summary' | translate"></app-tooltip>
                </div>
            </mat-radio-group>
        </section>
    </form>

    <ul>
        <ng-container  *ngFor="let organism of group.organisms">
            <li *ngIf="isComplete == null || organism.isComplete === isComplete">
                <mat-icon aria-label="check" class="complete" *ngIf="organism.isComplete">check</mat-icon>
                <mat-icon aria-label="uncheck" class="not-complete" *ngIf="!organism.isComplete">close</mat-icon>

                <span>{{ organism.text.fullLabel }}</span>
            </li>
        </ng-container>
    </ul>
</div>
